import styled from 'styled-components';

export const ApptHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
  width: 100%;
  flex-wrap: wrap;
  gap: var(--s3);
`;

export const ApptHeaderLeft = styled.div`
  display: flex;
  justify-content: left;
  flex-wrap: wrap;
  gap: var(--s3);
`;

export const ApptHeaderRight = styled.div`
  display: flex;
  justify-content: right;
  flex-wrap: wrap;
  gap: var(--s3);
  padding-right: var(--s5);
`;
